<template>
  <LoadingSpinner v-if="loading" />
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
export default {
  name: "VerifyInvitation",
  components: { LoadingSpinner },
  created() {
    this.loading = true;

    if (this.loggedIn) {
      this.$router.push({ name: "offerSearch" });
    } else {
      this.$store
        .dispatch("user/verifyInvitation", this.$route.params.token)
        .then(res => {
          this.loading = false;
          if (res[0]) {
            
            this.$router.push({ name: "checkLastname" });
          } else {
            this.$store.commit("app/showNotification", {
              heading: res[1],
              buttons: {
                okay: {
                  text: "okay",
                  action: () => {
                    this.$router.push({ name: "offerSearch" });
                  }
                }
              }
            });
          }
        })
        .catch(err => {});
    }
  }
};
</script>
